import { defineComponent as _defineComponent } from 'vue'
import { TechnologyTenantDevicesTableItem } from '@/models/technologyTenantDevicesTableItem';
import { Routes } from '@/router/routes';
import { Logger } from '@/utils/logger';
import OldTimeZoneIndicator from '@/components/OldTimeZoneIndicator.vue';
import { tenantsService } from '@/services/tenants.service';
import TableWithActions from '@/components/tableWithActions/TableWithActions.vue';
import { metricsService } from '@/services/metrics.service';
import { onMounted, ref, shallowRef } from 'vue';
import { useAbortController } from '@/composables/misc';
import { useRoute, useRouter } from '@/composables/router';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TechnologyConsoleTenantDevices',
  setup(__props) {

const devices = shallowRef<TechnologyTenantDevicesTableItem[]>([]);
const isLoading = ref(true);
const tenantTimeZone = ref<string | null>(null);

const tableFields: ReadonlyArray<keyof TechnologyTenantDevicesTableItem> = [
  'deviceName',
  'equipmentNumber',
  'firstDataDate',
  'hoursPowerOn',
  'cuttingHours',
  'bmcVersion',
  'bvcVersion',
  'cuttingHeadType',
  'cuttingHeadSoftwareVersion',
  'cuttingHeadSerialNumber',
  'cuttingHeadBaseProductNumber',
  'cuttingHeadBeamShaperSerialNumber',
];

const { controller } = useAbortController();
const router = useRouter();
const route = useRoute();
const { t } = useI18n();

onMounted(async () => {
  tenantTimeZone.value = (await loadTenant())!.timeZone;

  try {
    devices.value = await metricsService.getDevicesInfo<
      TechnologyTenantDevicesTableItem[]
    >(+route.value.params.tenantIdDh!, controller.value);
  } finally {
    isLoading.value = false;
  }
});

async function loadTenant() {
  try {
    return await tenantsService.getByIdDh(+route.value.params.tenantIdDh);
  } catch (e) {
    Logger.error(
      `Error getting tenant with idDh '${route.value.params.tenantIdDh}'. Redirecting to home...`,
    );
    await router.push({ name: Routes.Index });
  }
}

function goToDevice(device: TechnologyTenantDevicesTableItem) {
  router.push({
    name: Routes.TechnologyConsoleDevice,
    params: { deviceId: device.deviceId },
  });
}

function addTitleToCuttingHeadColumns(column: any): any {
  const field = column.$options.propsData.field;

  if (isCuttingHeadField(field)) {
    return {
      title: t(`report.tenant_technology_devices_table.${field}_long`),
    };
  }
}

function isCuttingHeadField(field: string) {
  return field.startsWith('cuttingHead');
}

return { __sfc: true,devices, isLoading, tenantTimeZone, tableFields, controller, router, route, t, loadTenant, goToDevice, addTitleToCuttingHeadColumns, isCuttingHeadField, Routes, OldTimeZoneIndicator, TableWithActions }
}

})